import React, { Component } from 'react';
import './ModalDetail.css';

class ModalDetail extends Component {
  static defaultProps = {
    // leftButtonTitle:　'取消',
    rightButtonTitle:'确认',
    content:'',
    // contentBC:'',
    onCancel:()=>{},
    onOK:()=>{},
    // titleBC:'',
    title:'',
    flag:false,
  }
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }
  componentWillMount(){
    // document.getElementsByTagName('body')[0].setAttribute("style","overflow:hidden")
  }
  componentWillUnmount(){
    // document.getElementsByTagName('body')[0].setAttribute("style","")
  }
  render(){
    return (
      <div>
        {this.props.flag?<div  className='modal_container' >
          <div className='modal_view'>
            {this.props.title&&<div className='modal_title'>{this.props.title}
            </div>}
            <div className='modal_content' >{this.props.content}</div>
            <div className='modal_footer'>
              <p onClick={()=>this.props.onOK()}>{this.props.rightButtonTitle}</p>
            </div>
          </div>
        </div>:null
      }
      </div>
    );
  }
}


export default ModalDetail



// WEBPACK FOOTER //
// ./src/components/Modal/ModalDetail.js